import {controller, target} from '@github/catalyst'

@controller
class JobAnnotationsElement extends HTMLElement {
  @target closeButton: HTMLElement
  @target openButton: HTMLElement
  @target bodyContainer: HTMLElement

  close() {
    this.bodyContainer.hidden = true
    this.closeButton.hidden = true
    this.openButton.hidden = false
  }

  open() {
    this.bodyContainer.hidden = false
    this.closeButton.hidden = false
    this.openButton.hidden = true
  }
}
